/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import ButtonMenuIcon from 'DesignSystem/ButtonMenuIcon/index'
import React from 'react'
import TysiaIconApps from 'DesignSystem/Svgs/TysiaIconApps/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/Menu/Content/ConnectAppsAction/Content",
  isSelected
  
}) {
let tabSelectedTabValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.tab',
})
let constantData = 'connect-apps'
let aggregateData = fromAggregate.equals(tabSelectedTabValueData, constantData)
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  isSelected
  
})
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let dtColorsGreen700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.700'
        })
  return (<React.Fragment
>
<ButtonMenuIcon
  viewPath={`${viewPath}/ButtonMenuIcon`}
 marginRight={0}
 text="Apps"
 onClick={onClick}
 data="tab.selected.tab"
 data="'connect-apps'"
 aggregate="/Simple/Data/aggregate.js equals"
 isSelected={aggregateData}
>
{childProps => (
<TysiaIconApps
{...childProps}
  viewPath={`${viewPath}/TysiaIconApps`}
 width={16}
 height={16}
 stroke={childProps.isSelected ? dtColorsGreen700 : dtColorsNeutral600}
/>
)}
</ButtonMenuIcon>
{children}
</React.Fragment>)
}